import { Group } from "@dashboard-v3/api";
import { Box, Tooltip } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useFetch } from "utils/api/useFetch";
import HelpIcon from "@material-ui/icons/HelpOutlineOutlined";
import { useTranslation } from "react-i18next";

export default function GroupName({ id }: { id: string }) {
  const { t } = useTranslation("rules");
  const { data: group, isLoading, error } = useFetch<Group>(`/groups/${id}`);

  if (error) {
    return (
      <Tooltip title={t("GroupName.deletedTitle", { id })}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          gridGap="5px"
          style={{ textDecoration: "underline", textDecorationStyle: "dotted" }}
        >
          <Box fontStyle="italic" color="gray">
            {t("GroupName.unknown")}
          </Box>

          <HelpIcon style={{ fontSize: "1rem", color: "gray" }} />
        </Box>
      </Tooltip>
    );
  }

  if (isLoading) {
    return <Skeleton variant="text" width="10rem" />;
  }

  return <>{group.name}</>;
}
